const config = {
  // Get the base URL from the dynamically injected 'window.env' object
  // This is the single backend service URL - all API calls go through this
  // The Node.js service at /claim169-service/ handles all requests and proxies to Python service internally
  baseURL: process.env.REACT_APP_SERVICE_BASE_URL || window.env?.REACT_APP_SERVICE_BASE_URL || 'http://localhost:8100',
};

export default config;